import { Icon } from "@dgs/core";
import { t } from "i18next";
import { FC, HTMLProps } from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";

const sharedCss = css`
	font-size: 1rem;
	display: inline-flex;
	height: 1.5rem;
	vertical-align: middle;
	align-items: center;
	margin-top: ${({ theme }) => theme.spacing(2)};
	color: inherit;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`;

const StyledLink = styled(Link)`
	${sharedCss}
`;

const StyledAnchor = styled.a`
	${sharedCss}
`;

const Arrow = styled(Icon)`
	width: 16px;
	height: 16px;
	margin-right: ${({ theme }) => theme.spacing(1)};
`;

interface BackLinkProps {
	to: string;
}

export const BackLink: FC<BackLinkProps> = ({ to }) => {
	return (
		<StyledLink to={to}>
			<Arrow $icon="caret_left" />
			{t("Back")}
		</StyledLink>
	);
};

export const BackAnchor: FC<HTMLProps<HTMLAnchorElement>> = (props) => {
	return (
		<StyledAnchor {...props}>
			<Arrow $icon="caret_left" />
			{t("Back")}
		</StyledAnchor>
	);
};
